module.exports = __webpack_public_path__ + "media/a2.cfd28a7e.wav";